import styles from "./DeliveryHighlights.module.scss";
import { Props } from "../../DeliveryAndGuaranteesMessageUI";
import { ClickAndCollect } from "../ClickAndCollect/ClickAndCollect";
import { ListWithIcon } from "@/components/DeliveryAndGuaranteesMessage/components/ListWithIcon";
import { checkTimedContentIsActive } from "@/components/ProductAccordion/components/ProductDeliveryOptionsAccordion/util/checkTimedContentIsActive.ts";

export const DeliveryHighlights = ({
  message,
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  showClickAndCollect = "never",
  showFreeReturns = false,
  showFreeReturnsWithRestrictions = false,
  hideDeliveryMessage,
  returnsEndDate,
  returnsStartDate,
  show2ManDeliveryMessage = false,
  twoManDeliveryPrice = undefined,
  isBraExclusion = false,
}: Props) => {
  if (hideDeliveryMessage) {
    return null;
  }

  const showClickAndCollectMessage =
    showClickAndCollect === "always" ||
    (showClickAndCollect === "available" && isClickAndCollectAvailable);

  const showTimedFrameCopy = checkTimedContentIsActive(
    returnsStartDate,
    returnsEndDate,
  );

  const returnsMessage = (() => {
    if (!showFreeReturnsWithRestrictions) return "";

    const baseMessage = ", restrictions apply";
    return isBraExclusion ? `${baseMessage} to stick-on bras` : baseMessage;
  })();

  const highlights = [
    showClickAndCollectMessage && (
      <ClickAndCollect
        key="clickAndCollect"
        isClickAndCollectAvailable={isClickAndCollectAvailable}
        isOverClickAndCollectThreshold={isOverClickAndCollectThreshold}
      />
    ),
    message && (
      <ListWithIcon
        key="delivery"
        cssClasses={styles.deliveryMessage}
        textMessage={message}
        iconType="delivery"
      />
    ),
    show2ManDeliveryMessage && twoManDeliveryPrice !== undefined && (
      <ListWithIcon
        key="twoManDelivery"
        cssClasses={styles.deliveryMessage}
        textMessage={` Standard delivery £${twoManDeliveryPrice.toFixed(2)}`}
        iconType="delivery"
      />
    ),
    showFreeReturns && (
      <ListWithIcon
        key="freeReturns"
        cssClasses={styles.deliveryMessage}
        textMessage={` Free returns${showTimedFrameCopy ? " until 23 January" : ""}${returnsMessage}`}
        iconType="returns"
      />
    ),
  ].filter(Boolean);

  if (highlights.length === 0) {
    return null;
  }

  return (
    <ul data-testid="product:delivery-message" className={styles.message}>
      {highlights}
    </ul>
  );
};
